import type { ThemeName } from '@roomtreatment/design'

/**
 * Theme preference — server-safe half (no React, no DOM at import).
 *
 * The preference has THREE values, not two. `system` is the default and the
 * common case: follow `prefers-color-scheme`, live, with nothing stored. An
 * explicit `light`/`dark` is the exception the user opted into, and it is the
 * only thing ever written to storage — so clearing it is how you go back to
 * following the OS, and a binary toggle could never express that.
 */
export type ThemePreference = 'system' | ThemeName

export const THEME_STORAGE_KEY = 'rt-theme'

/**
 * Runs in <head>, synchronously, before the body paints — which is the only
 * way to avoid a light flash for a dark visitor on a statically rendered page.
 * The server cannot know the answer (the OS setting never reaches it, and
 * reading a cookie would force every marketing page dynamic), so the browser
 * decides before first paint instead.
 *
 * It always writes a RESOLVED theme to <html>, so every consumer — CSS and
 * canvas alike — reads one attribute and never has to consult matchMedia
 * itself. Deliberately tiny and dependency-free: it is inlined into every page.
 */
export const THEME_BOOT_SCRIPT = `(function(){try{var p=localStorage.getItem('${THEME_STORAGE_KEY}');var d=p==='dark'||(p!=='light'&&window.matchMedia('(prefers-color-scheme: dark)').matches);var r=document.documentElement;r.setAttribute('data-theme',d?'dark':'light');r.style.colorScheme=d?'dark':'light';}catch(e){}})();`
